/* eslint-disable prettier/prettier */
export function getSunday() {
  var monthNames = [
    'Jan.',
    'Feb.',
    'March',
    'Apr.',
    'May',
    'June',
    'July',
    'Aug.',
    'Sept.',
    'Oct.',
    'Nov.',
    'Dec.'
  ];
  var dayOfWeek = 0; //Sunday
  var date = new Date();
  var diff = dayOfWeek - date.getDay();
  if (diff <= 0) {
    if (diff === 0 && date.getHours() < 13) {
      date.setDate(date.getDate());
    } else {
      date.setDate(date.getDate() + (7 + diff));
    }
  } else if (diff > 0) {
    date.setDate(date.getDate() + diff);
  }

  //console.log(
  //   monthNames[date.getMonth()] +
  //     " " +
  // date.getDate() +
  // ", " +
  // date.getFullYear()
  // );
  return (
    monthNames[ date.getMonth() ] +
    ' ' +
    date.getDate() +
    ', ' +
    date.getFullYear()
  );
}
